export default "__VITE_ASSET__DbbuuPo8__"